import { useQuery } from '@tanstack/react-query';
import { http } from '@lib/api';
import { queryKeys } from '@lib/queryKeys';
import { addCalendarDays } from '@lib/calendar-day';
import type { BoardWindow } from './boardModel';
import { toBoardDays, type BoardWire } from './boardWire';

function boardWinEnd(boardWin: BoardWindow): string {
  return addCalendarDays(boardWin.from, boardWin.days - 1);
}

/**
 * The batch board for `boardWin` (`boardWindow`): from `boardWin.from`, `boardWin.days`
 * dates. Keyed under `['dispatch', …]`, so a dispatch run's
 * `queryKeys.dispatch.all()` invalidation refreshes the board too.
 */
export function useBoardDays(boardWin: BoardWindow, enabled: boolean) {
  const { from, days } = boardWin;
  return useQuery({
    queryKey: queryKeys.dispatch.board(from, boardWinEnd(boardWin)),
    queryFn: async () =>
      toBoardDays(await http.get<BoardWire>('/api/dispatch/board', { params: { from, days } })),
    staleTime: 60_000,
    enabled,
  });
}
